<template>
  <div>
  <div>Hello status</div>
  <svg id='brewstatus' height='100px'>
  </svg> 
</div>
</template>
<script>
import * as d3 from 'd3'
export default {
  name: 'brewstatus',
  data () {
    return {
      isReady: false,
      progressPercent: 0,
      startBrew: 0,
      endBrew: 0,
      volume: [1.00, 0.98, 0.74, 0.50, 0.25, 0.1],
      test: [{date: '24-Apr-07', close: 90.24},
              {date: '25-Apr-07', close: 80.24},
              {date: '26-Apr-07', close: 75.24},
              {date: '27-Apr-07', close: 70.24},
              {date: '28-Apr-07', close: 20.24}]
    }
  },
  watch: {

  },
  mounted () {
    this.setUpVisualization()
  },
  destroyed () {

  },
  methods: {
    getScales () {

    },
    breakDownVisualization () {

    },
    setUpVisualization () {
      /* eslint-disable no-unused-vars */
      let svg = d3.select('brewstatus')
      let margin = {top: 20, right: 20, bottom: 30, left: 50}
      let width = +svg.attr('width') - margin.left - margin.right
      let height = +svg.attr('height') - margin.top - margin.bottom
      let g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
      let parseTime = d3.timeParse('%d-%b-%y')
      let x = d3.scaleTime().rangeRound([height, 0])
      let y = d3.scaleTime().rangeRound([height, 0])
      var area = d3.area()
            .x(function (d) { return x(d.date) })
            .y1(function (d) { return y(d.close) })
      g.append('path')
      .datum(this.test)
      .attr('fill', 'steelblue')
      .attr('d', area)
      /* eslint-enable no-unused-vars */
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/visualization/BrewStatus.vue